module.exports = __webpack_public_path__ + "img/p2-71.2e235d72.png";